import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AppRoutes } from './router';

// ルート変更時に常にトップへ戻す + スクロールコンテナのインスタンスをルートごとに分離
function AppShell() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // #anchor 付き遷移のときだけブラウザ既定動作に任せるなら if (!hash)
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname, search, hash]);

  return (
    // ここがサイト全体のスクロールコンテナなら key を付けて別インスタンス扱いに
    <main key={pathname} className="min-h-screen">
      <AppRoutes />
    </main>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
